import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer id='footer' className='footer'>
        <hr />
        <div className='container mx-auto'>
          <div className='row m-4'>
            <div className='col-sm-4 col-xs-12'>
              <div className='list-group list-group-flush'>
                <Link to="/">
                  <span className='border border-primary list-group-item m-1 rounded'>
                    Home
                  </span>
                </Link>
                <Link to="/contact">
                  <span className='border border-primary list-group-item m-1 rounded'>
                    Contact
                  </span>
                </Link>
              </div>
            </div>
            <div className='col-sm-4 col-xs-12'>
              <div className='list-group list-group-flush'>
                <a href='https://www.facebook.com/christopher.busick'><span className='border border-primary list-group-item m-1 rounded'><i className='fa fa-facebook'/></span></a>
                <a href='https://www.linkedin.com/in/busick'><span className='border border-primary list-group-item m-1 rounded'><i className='fa fa-linkedin'/></span></a>
              </div>
            </div>
            <div className='col-sm-4 col-xs-12'>
              <div className='list-group list-group-flush'>
                <Link to="/privacy">
                  <span className='border border-primary list-group-item m-1 rounded'>
                    Privacy Policy
                  </span>
                </Link>
                <Link to="/terms">
                  <span className='border border-primary list-group-item m-1 rounded'>
                    Terms of Use
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className='row m-4'>
         <div className='text-center mx-auto'>
          &copy; 2018, cbusick.com
          <br />
          Created by me (Chris Busick) using React and Bootstrap.
          <br />
          Serverlessly hosted on AWS</div>
        </div>
      </footer>
    );
  }
}

export default Footer;
